module.exports = __webpack_public_path__ + "img/paesaggio 1.9d817bb8.jpeg";